import React from "react";
import Logo from "../SVGs/Logo";
import LanguageSwitcher from "../LanguageSwitcher";
import styles from "./Navbar.module.scss";

import HamburgerMenu from "./HamburgerMenu";

function Navbar({ light }) {
  // STATES
  // STORE STATES
  // HOOKS
  // METHODS
  // EFFECTS
  // RENDER
  return <HamburgerMenu light={light} />;
}
export default Navbar;
